"use client";

import { c as _c } from "react/compiler-runtime";
import JobAdVideo from "~/components/job-page/jobadvideo/jobad-video-eon";
import { useLanguage } from "~/translations/loader/use-language";
export default function BehindTheScenesEcon() {
  const $ = _c(4);
  const t = useLanguage();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="mb-10 text-center font-bold text-4xl lg:mb-16 xl:text-5xl" data-source="text">Behind the scenes</h2>;
    t1 = <JobAdVideo buttonColor="bg-accent cursor-pointer" thumbnailSrc="images/jobad/econ/thumbnail_exp_reports.png" videoUrl="econ/exp_report.mp4" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.econ_behind_the_scences) {
    t2 = <section className="outer-container bg-primary py-container text-white print:hidden" id="behindTheScenes"><div className="inner-container">{t0}<div>{t1}<div className="bg-white p-10 text-center font-medium text-foreground text-lg"><p data-source="lc">{t.econ_behind_the_scences}</p></div></div></div></section>;
    $[2] = t.econ_behind_the_scences;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}